import { useAppState } from '@Contexts/appContext';
import { useCallback } from 'react';

const key = 'lastWeighedOrder';

export function useLastWeighedOrder() {
    const { current, set } = useAppState();

    const lastWeighedOrder = current[key] ?? '';
    const setLastWeighedOrder = useCallback((id: string) => set(key, id), [set]);

    return {
        lastWeighedOrder,
        setLastWeighedOrder,
    };
}
